import React from 'react';
import { Link } from 'react-router-dom';
import { Row } from 'reactstrap';

import './General.css';
import LogoCrazyClicker from '../images/logo.png';

const Header = () => {
  return (
    <Row className="row-header vw-100">
      <Link to="/">
        <img className="logoCrazyClicker" src={LogoCrazyClicker} alt="Logo CrazyClicker" />
      </Link>
    </Row>
  );
};

export default Header;
